// extracted by mini-css-extract-plugin
export default {"root":"BigAmount_root__IQnXH","label":"BigAmount_label__AqZat","number":"BigAmount_number__3jlTU"};